import { NgIf, AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { AgrLocationSummaryModule } from '@next/core-lib/components';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { FeatureFlagService } from '@next/core-lib/featureflag';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { map, Observable, switchMap } from 'rxjs';
import { ShopFeatureFlags } from 'src/app/shared/shop-feature-flags';
import { clearOrdersRequest } from 'src/app/store/actions';
import { selectOrders } from 'src/app/store/selectors';
import { Environment } from 'src/environments/environment.model';

import { SearchFavoritesComponent } from '../../product/components/favorites/search-favorites.component';
import { ReturnButtonComponent } from '../../product/components/return-button/return-button.component';

import { CustomerBlockedNotificationComponent } from '../../standalone/customer-blocked-notification/customer-blocked-notification';
import { CatalogComponent } from '../catalog/catalog.component';
import { RepeatOrderTeaserComponent } from '../repeat-order/components/teaser/repeat-order-teaser.component';

@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    AgrLocationSummaryModule,
    ReturnButtonComponent,
    SearchFavoritesComponent,
    MatButton,
    RouterLink,
    MatIcon,
    RepeatOrderTeaserComponent,
    MatDivider,
    CustomerBlockedNotificationComponent,
    CatalogComponent,
    AsyncPipe,
    AgrI18nSharedModule,
  ],
})
export class ShopComponent implements OnInit, OnDestroy {
  location$ = this.store.select(UserSelectors.selectLocation);
  customer$ = this.store.select(UserSelectors.selectCustomer);
  orders$ = this.store.select(selectOrders);
  hasOrderBlock$ = this.location$.pipe(map((location) => location?.orderBlock));
  isFavoritesEnabled$: Observable<boolean>;

  constructor(
    private readonly store: Store<RootState>,
    @Inject(EnvironmentInjector) public environment: Environment,
    private featureFlagService: FeatureFlagService,
  ) {}

  ngOnInit(): void {
    const featureFlags$ = this.customer$.pipe(
      map((selectedCustomer) => selectedCustomer?.shipTos[0]?.salesAreas[0]?.salesOrganization),
      switchMap((salesOrganization) => this.featureFlagService.getFeatureFlagsForSalesArea(salesOrganization)),
    );
    this.isFavoritesEnabled$ = featureFlags$.pipe(map((featureFlags) => featureFlags.includes(ShopFeatureFlags.enableFavorites)));
  }

  ngOnDestroy(): void {
    this.store.dispatch(clearOrdersRequest());
  }
}
